import { render, staticRenderFns } from "./CreateAssetTransfer.vue?vue&type=template&id=15771707&"
import script from "./CreateAssetTransfer.vue?vue&type=script&lang=ts&"
export * from "./CreateAssetTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15771707')) {
      api.createRecord('15771707', component.options)
    } else {
      api.reload('15771707', component.options)
    }
    module.hot.accept("./CreateAssetTransfer.vue?vue&type=template&id=15771707&", function () {
      api.rerender('15771707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Transactions/CreateAssetTransfer.vue"
export default component.exports